import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../../../../config";
// import { useSelector } from "react-redux";
import { Header, Footer } from "../../../../../layouts";
import ProductDetail from "../../../../../components/products/productDetailsComp";
import Spinner from "../../../../../components/spinner";
import ProductRecommendation from "../../../../../components/products/ProductRecommendation";

const ProductDetailClient = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const getProduct = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/get/one/${decodeURIComponent(atob(id))}`);
      console.log("details", response.data.data);
      setProduct(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false); 
    }
  };

  useEffect(() => {
    getProduct();
  }, [id]);

  return (
    <>
      <Header sub="market-place" />
      {/* <HeroSm sub = "market-place" /> */}
      {/* title={lang("t6")} */}

      {isLoading ? ( // Render spinner while loading
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <Spinner color={"success"} size={3} />
        </div>
      ) : (
        product && (
          <div className=" container content-space-t-4 content-space-b-2  ">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-link text-decoration-none fw-semibold "
            >
              <i className="bi bi-arrow-left me-2"></i> Back to Shop
            </button>

            <ProductDetail product={product} />

            <ProductRecommendation productDetail={product} />
          </div>
        )
      )}
      <Footer sub="market-place" />
    </>
  );
};

export default ProductDetailClient;
